import { BaseEntity } from "yt-ng-framework";

export class FakDokumentPovezaniAvansi extends BaseEntity{

    constructor(){
        super();
    }    

    BrojDokumenta: string;
    UkPdvVisa: number;
    UkPdvNiza: number;

    Deserialize(input: any){
        this.BrojDokumenta = input.BrojDokumenta;
        this.UkPdvVisa = input.UkPdvVisa;
        this.UkPdvNiza = input.UkPdvNiza;
        return this;
    }

    Serialize(input: FakDokumentPovezaniAvansi){
        return input;
    }
}